export default function AboutSection() {
  return (
    <section className="relative bg-gradient-to-b from-[#3E2723] to-[#1B0F0A] py-16 md:py-24 overflow-hidden">
      <div className="w-full px-4 md:px-6 lg:px-16">
        <div className="max-w-[55%]">
          <div className="inline-flex items-center gap-1.5 bg-accent-100/20 px-3 py-1.5 rounded text-xs font-medium text-accent-200 mb-6">
            <span className="text-accent-300">/</span>
            <span>SEO VERIFIED</span>
          </div>
          <h2 className="font-heading text-4xl md:text-5xl lg:text-[56px] leading-[1.05] font-bold text-white mb-6">
            The Only OOPBuy Spreadsheet You Need
          </h2>
          <p className="text-white/75 text-base md:text-lg leading-relaxed max-w-xl font-light">
            Built from the ground up for serious product resellers, the OOPBuy Spreadsheet system replaces chaotic manual tracking with a structured, category-driven workflow across all 14 product categories.
          </p>
        </div>

        <div className="mt-16 md:mt-20 flex flex-col lg:flex-row items-start gap-10 lg:gap-20">
          <div className="w-full lg:w-[400px] shrink-0">
            <div className="w-full aspect-square rounded-2xl overflow-hidden bg-background-100/10">
              <img
                src="https://readdy.ai/api/search-image?query=Elegant%20minimalist%20product%20photography%20featuring%20a%20curated%20collection%20of%20lifestyle%20fashion%20items%20including%20a%20pair%20of%20retro%20sneakers%20a%20folded%20linen%20shirt%20and%20a%20small%20candle%20arranged%20aesthetically%20on%20a%20light%20oak%20surface%20with%20soft%20morning%20sunlight%20streaming%20diagonally%20creating%20long%20gentle%20shadows%20editorial%20lifestyle%20photography%20high%20detail%20warm%20neutral%20palette&width=800&height=800&seq=about-mockup-v2&orientation=squarish"
                alt="OOPBuy Spreadsheet mockup"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
          <div className="flex flex-col gap-6">
            <div>
              <span className="font-heading text-[80px] md:text-[96px] leading-none font-bold text-white">10K+</span>
            </div>
            <p className="text-white/75 text-base md:text-lg leading-relaxed font-light max-w-md">
              Products tracked across 14 categories. Daily restock alerts. Real-time inventory synchronization through the OOPBuy Spreadsheet platform.
            </p>
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center justify-center w-[180px] h-[50px] rounded-full bg-white text-foreground-950 font-semibold text-sm whitespace-nowrap cursor-pointer hover:bg-background-100 transition-colors duration-200"
            >
              Buy It Now
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}